import React, { useEffect, useCallback } from "react";
import { Navbar, Dropdown, Image, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import ProfileImg from "../assets/images/default-profile-icon.png"
import "./styles/navbar.css";
import { useSubmitRefreshTokenMutation, useLogoutMutation } from "../Services/myAccountAPI";
import { useNavigate } from "react-router-dom";

export default function BootstrapNavbar() {
  const navigate = useNavigate();

  const [logout] = useLogoutMutation();
  const [submitRefreshToken, { isError: isErrorRefreshToken }] =
    useSubmitRefreshTokenMutation();

  const handleLogout = useCallback(async () => {
    try {
      const response = await logout().unwrap();
      console.log("response", response);
      localStorage.clear();
      navigate("/login");
    } catch (error) {
      localStorage.clear();
      navigate("/login");
    }
  }, [logout, navigate]);

  useEffect(() => {
    const interval = setInterval(() => {
      handleLogout();
    }, 3600000);

    return () => clearInterval(interval);
  }, [handleLogout]);

  const handleSubmitRefreshToken = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) return;

    let postData = { refresh: refreshToken };

    try {
      const response = await submitRefreshToken(postData).unwrap();

      if (response) {
        localStorage.setItem("accessToken", response.access_token);
        localStorage.setItem("refreshToken", response.refresh_token);
      }
    } catch (err) {
      localStorage.clear();
      navigate("/login");
    }
  };

  useEffect(() => {
    if (isErrorRefreshToken) {
      navigate("/login");
      localStorage.clear();
    }
  }, [isErrorRefreshToken, navigate])

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleSubmitRefreshToken();
    }, 10000);

    return () => clearInterval(intervalId);
  });

  //   useEffect(() => {
  //     const logoutTime = 6 * 60 * 60 * 1000;

  //     const logout = () => {
  //         localStorage.clear();
  //         navigate("/login");
  //     };

  //     const storedTime = localStorage.getItem("loginTime");
  //     const currentTime = new Date().getTime();

  //     if (storedTime && currentTime - storedTime > logoutTime) {
  //         logout();
  //     } else {
  //         const timer = setTimeout(logout, logoutTime - (currentTime - storedTime));
  //         return () => clearTimeout(timer);
  //     }
  // }, [navigate]);

  return (
    <>
      {/* Navbar */}
      <Navbar variant="dark" expand="lg" className="px-3">
        <Container fluid>

          <Navbar.Brand as={Link} to="/"></Navbar.Brand>

          {/* User Menu */}
          <Dropdown align="end">
            <Dropdown.Toggle variant="outline-light" className="d-flex align-items-center">
              <Image src={ProfileImg} width={30} height={30} roundedCircle />
              <span className="ms-2">Admin</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item as={Link} to="/edit-profile">

                Profile
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/change-password">

                Change Password
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={handleLogout}>

                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Container>
      </Navbar>


    </>
  );
}
